import { render, staticRenderFns } from "./riskcontrol.vue?vue&type=template&id=6318aa32&"
import script from "./riskcontrol.vue?vue&type=script&lang=js&"
export * from "./riskcontrol.vue?vue&type=script&lang=js&"
import style0 from "./riskcontrol.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports